import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CabecalhoPadrao from "../components/CabecalhoPadrao/CabecalhoPadrao";
import DropdownPadrao from "../components/DropdownPadrao/DropdownPadrao";
import FiltroPadrao from "../components/FiltroPadrao/FiltroPadrao";
import InputPadrao from "../components/InputPadrao/InputPadrao";
import TabelaPadrao from "../components/TabelaPadrao/TabelaPadrao";
import { useEmpresa } from "../hooks/DropdownHooks";
import FiltroURLWrapper from "../hooks/FiltroUrlHook";
import api from '../services/api';
import FiltroUtils from '../utils/FiltroUtils';
import { APP_ROUTES, getEditarPath } from "../services/app_routes";
import { isSuperAdmin, PERMISSOES } from "../utils/PermissaoUtils";
import PAGINATION from "../utils/PaginacaoUtils";
import Carregamento from "../components/Carregamento/Carregamento";
import { BREAKPOINTS_PADRAO, OPCOES_SITUACAO, COLUNA_SITUACAO, definirColunasFixas } from "../utils/ListagemUtils";
import Mensagens from "../utils/MensagemUtils";

const ListagemUsuario = () => {
    const navigate = useNavigate();
    const [usuarios, setUsuarios] = useState([]);
    const [totalUsuarios, setTotalUsuarios] = useState(0);
    const [carregando, setCarregando] = useState(false);
    const [buscaInicial, setBuscaInicial] = useState(true);
    
    const filtrarRef = useRef(null);
    const currentPageRef = useRef(PAGINATION.DEFAULT_FIRST_PAGE);
    const { itens: empresas, carregando: carregandoEmpresas } = useEmpresa();
    
    const carregamentoGeral = () => {
      return carregando || carregandoEmpresas;
    }
    
    const filtrosPadrao = {
        nome: "",
        email: "",
        empresa: "",
        situacaoCadastro: "",
    };
    
    const colunas = [
      { titulo: 'Nome', campo: 'nome' },
      COLUNA_SITUACAO(),
      { titulo: 'E-mail', campo: 'email' },
      { titulo: 'Grupo Permissão', campo: 'grupoPermissao' },
      { titulo: 'Login', campo: 'login' },
      { titulo: 'Empresa', campo: 'empresa' },
    ];
    
    const colunasPermissao = {
      'empresa': isSuperAdmin(),
    };
    
    const colunasFixas = definirColunasFixas();
    
    useEffect(() => {
        // Garantir que a busca inicial seja feita com situacaoCadastro=ATIVO
        if (filtrarRef.current) filtrarRef.current(0); // Forçar página 0 para busca inicial
    }, []); 

    return (
      <FiltroURLWrapper
        defaultFilters={filtrosPadrao}
        defaultPage={PAGINATION.DEFAULT_FIRST_PAGE}
        defaultSize={PAGINATION.DEFAULT_PAGE_SIZE}
        basePath={'/usuario/visualizar'}
      >
        {({
          currentPage,
          pageSize,
          filtros,
          setFiltros,
          aplicarFiltros,
          limparFiltros,
          proximaPagina,
          paginaAnterior,
          irParaPagina,
        }) => {
          const fetchUsuarios = async queryString => {
            setCarregando(true);
            try {
              const apiResponse = await api.get('/usuario_' + queryString);
              if (apiResponse.success) {
                const data = apiResponse.data;
                const usuarios = data.content;
                const page = data.page;
                setUsuarios(usuarios);
                setTotalUsuarios(page.totalElements);
              }
            } catch (error) {
              console.error('Erro ao buscar usuários:', error);
              setUsuarios([]);
              setTotalUsuarios(0);
            } finally {
              setCarregando(false);
            }
          };

          // filtrar agora aceita page como argumento
          const filtrar = async (page = 0) => {
            // Se for a busca inicial (primeira execução) e não há filtro de situação definido, aplicar ATIVO
            if (buscaInicial && !filtros.situacaoCadastro) {
              const filtrosComSituacao = { ...filtros, situacaoCadastro: "ATIVO" };
              // Atualiza o estado dos filtros para que o dropdown mostre "ATIVO"
              setFiltros(filtrosComSituacao);
              setBuscaInicial(false);
              
              const queryStringComSituacao = FiltroUtils.applyPageFilter(page, pageSize, filtrosComSituacao);
              await fetchUsuarios(queryStringComSituacao);
            } else {
              // Para buscas subsequentes, usar os filtros exatamente como o usuário definiu
              const { queryString } = aplicarFiltros(page);
              await fetchUsuarios(queryString);
            }
          };
          
          if (filtrarRef.current !== filtrar) {
            filtrarRef.current = filtrar;
          }
          
          if (currentPageRef.current !== currentPage) {
            currentPageRef.current = currentPage;
            filtrar(currentPage);
          }

          // Sempre que pesquisar, volta para página 0 e filtra
          const pesquisar = async () => {
            setBuscaInicial(false); // Marcar que não é mais busca inicial
            irParaPagina(0);
            await filtrar(0);
          };

          // Função customizada para limpar filtros
          const limparFiltrosCustom = () => {
            setBuscaInicial(false); // Marcar que não é mais busca inicial
            limparFiltros();
          };

          const handleEditar = usuario => {
            if (usuario) {
              navigate(getEditarPath(APP_ROUTES.USUARIO_EDITAR, usuario.idUsuario));
            } else {
              console.error('Não foi possível identificar o ID do usuário:', usuario);
            }
          };

          const handleCriarUsuario = () => {
            navigate(APP_ROUTES.USUARIO_CADASTRO);
          };

          return (
            <div>
              {carregamentoGeral() && <Carregamento />}
              
              <CabecalhoPadrao
                titulo={Mensagens.USUARIO.LISTAGEM.TITULO}
                permissao={PERMISSOES.USUARIO_CADASTRAR}
                onClick={handleCriarUsuario}
              />
              
              <FiltroPadrao filtrar={pesquisar} limparFiltros={limparFiltrosCustom}>
                <InputPadrao
                  label={'Nome'}
                  placeholder={'Digite o nome'}
                  value={filtros.nome}
                  name="nome"
                  onChange={e => setFiltros({ ...filtros, nome: e.target.value })}
                />
                <InputPadrao
                  label={'E-mail'}
                  placeholder={'Digite o e-mail'}
                  value={filtros.email}
                  name="email"
                  onChange={e => setFiltros({ ...filtros, email: e.target.value })}
                />
                <DropdownPadrao
                  permissao={PERMISSOES.EMPRESA_LISTAR}
                  label={'Empresa'}
                  showFilter={true}
                  options={empresas}
                  value={filtros.empresa}
                  name="empresa"
                  onChange={e => setFiltros({ ...filtros, empresa: e.target.value })}
                />
                <DropdownPadrao
                  label={'Situação Cadastro'}
                  showFilter={true}
                  options={OPCOES_SITUACAO}
                  value={filtros.situacaoCadastro}
                  name="situacaoCadastro"
                  onChange={e => setFiltros({ ...filtros, situacaoCadastro: e.target.value })}
                />
              </FiltroPadrao>
              
              <TabelaPadrao
                permissaoEditar={PERMISSOES.USUARIO_EDITAR}
                dados={usuarios}
                colunas={colunas}
                totalItems={totalUsuarios}
                paginaAtual={currentPage}
                tamanhoPagina={pageSize}
                carregando={carregando}
                onEditar={handleEditar}
                onProximaPagina={proximaPagina}
                onPaginaAnterior={paginaAnterior}
                onIrParaPagina={irParaPagina}
                colunasFixas={colunasFixas}
                breakpoints={BREAKPOINTS_PADRAO}
                colunasPermissao={colunasPermissao}
              />
            </div>
          );
        }}
      </FiltroURLWrapper>
    );
};
 
export default ListagemUsuario;